import api from "../../../../utils/api";
const apiUrl = process.env.REACT_APP_MOCK_RESUME_URL;

export const fetchExternalList = async (
  page = 0, 
  limit = 10, 
  invoiceType = 'standard', 
  companyName = '', 
  duration = '', 
  startDate = '', 
  endDate = ''
) => {
  try {
    const invoiceTypeMapping = {
      'standard': 'standard',
      'tax': 'taxbased'
    };
    
    const mappedInvoiceType = invoiceTypeMapping[invoiceType] || 'standard';
    let queryParams = `page=${page + 1}&size=${limit}&invoiceType=${mappedInvoiceType}`;
    if (companyName && companyName.trim()) {
      queryParams += `&companyName=${encodeURIComponent(companyName.trim())}`;
    }
    if (duration && duration.trim()) {
      queryParams += `&duration=${encodeURIComponent(duration)}`;
    }
    if (startDate && startDate.trim()) {
      queryParams += `&startDate=${encodeURIComponent(startDate)}`;
    }
    
    if (endDate && endDate.trim()) {
      queryParams += `&endDate=${encodeURIComponent(endDate)}`;
    }
    
    const res = await api.get(
      `/payments/customInvoice?${queryParams}`,
      {
        baseURL: apiUrl
      }
    );
    return res;
  } catch (err) {
    return err;
  }
};